/**
 * Embedded Stripe Payment Element rollout flag (BR-09).
 *
 * The embedded (in-page Payment Element) flow is the default. Setting
 * REACT_APP_USE_EMBEDDED_PAYMENT=false falls back to the legacy hosted Stripe
 * Checkout redirect on every flow, so the rollout can be reverted without a
 * code change.
 */
export const isEmbeddedPaymentEnabled = () =>
  process.env.REACT_APP_USE_EMBEDDED_PAYMENT !== 'false';

// Singleton Stripe.js instance. loadStripe must run once per page load; both the
// inline (TransactionPage) and modal (StripePaymentModal) embedded flows share it.
let stripePromise;
export const getStripePromise = () => {
  if (typeof window === 'undefined') {
    return null;
  }
  if (!stripePromise) {
    // Lazy require so SSR bundles don't pull in Stripe.js at module load.
    // eslint-disable-next-line global-require
    const { loadStripe } = require('@stripe/stripe-js');
    stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
  }
  return stripePromise;
};
